/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldConfig } from './FieldConfig';
import {
    FieldConfigFromJSON,
    FieldConfigFromJSONTyped,
    FieldConfigToJSON,
    FieldConfigToJSONTyped,
} from './FieldConfig';
import type { SocialPostConfig } from './SocialPostConfig';
import {
    SocialPostConfigFromJSON,
    SocialPostConfigFromJSONTyped,
    SocialPostConfigToJSON,
    SocialPostConfigToJSONTyped,
} from './SocialPostConfig';
import type { DataSource } from './DataSource';
import {
    DataSourceFromJSON,
    DataSourceFromJSONTyped,
    DataSourceToJSON,
    DataSourceToJSONTyped,
} from './DataSource';

/**
 * 
 * @export
 * @interface EventType
 */
export interface EventType {
    /**
     * 
     * @type {string}
     * @memberof EventType
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EventType
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof EventType
     */
    updatedAt: number;
    /**
     * The name of the event type (e.g., "KILL", "DEATH")
     * @type {string}
     * @memberof EventType
     */
    name: string;
    /**
     * Whether to save the data to the global user state storage
     * @type {boolean}
     * @memberof EventType
     */
    isState?: boolean;
    /**
     * When true, fires a CUSTOM_EVENT streak signal on successful processing
     * @type {boolean}
     * @memberof EventType
     */
    isStreakSignal?: boolean;
    /**
     * The ID of the game this event type is associated with
     * @type {Array<string>}
     * @memberof EventType
     */
    gameIds?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: FieldConfig; }}
     * @memberof EventType
     */
    fields: { [key: string]: FieldConfig; };
    /**
     * 
     * @type {Array<DataSource>}
     * @memberof EventType
     */
    sourcePriority?: Array<DataSource>;
    /**
     * Optional. Present on SOCIAL-subtype EventTypes that get used by `verifySocialPost`. The required hashtag, supported platforms, and per-user round cap that the verifier reads at submit time. Every social-post objective references one EventType via triggerEvent.eventTypeId — this is where the config lives.
     * @type {SocialPostConfig}
     * @memberof EventType
     */
    socialPostConfig?: SocialPostConfig;
    /**
     * 
     * @type {DataSource}
     * @memberof EventType
     */
    source?: DataSource;
}



/**
 * Check if a given object implements the EventType interface.
 */
export function instanceOfEventType(value: object): value is EventType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function EventTypeFromJSON(json: any): EventType {
    return EventTypeFromJSONTyped(json, false);
}

export function EventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'isState': json['isState'] == null ? undefined : json['isState'],
        'isStreakSignal': json['isStreakSignal'] == null ? undefined : json['isStreakSignal'],
        'gameIds': json['gameIds'] == null ? undefined : json['gameIds'],
        'fields': (mapValues(json['fields'], FieldConfigFromJSON)),
        'sourcePriority': json['sourcePriority'] == null ? undefined : ((json['sourcePriority'] as Array<any>).map(DataSourceFromJSON)),
        'socialPostConfig': json['socialPostConfig'] == null ? undefined : SocialPostConfigFromJSON(json['socialPostConfig']),
        'source': json['source'] == null ? undefined : DataSourceFromJSON(json['source']),
    };
}

export function EventTypeToJSON(json: any): EventType {
    return EventTypeToJSONTyped(json, false);
}

export function EventTypeToJSONTyped(value?: EventType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'isState': value['isState'],
        'isStreakSignal': value['isStreakSignal'],
        'gameIds': value['gameIds'],
        'fields': (mapValues(value['fields'], FieldConfigToJSON)),
        'sourcePriority': value['sourcePriority'] == null ? undefined : ((value['sourcePriority'] as Array<any>).map(DataSourceToJSON)),
        'socialPostConfig': SocialPostConfigToJSON(value['socialPostConfig']),
        'source': DataSourceToJSON(value['source']),
    };
}

